'use client';

import { debug } from './logger';

export function getEnvironmentConfig() {
  // Get the current hostname
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';

  // Debug logging
  debug('[Environment Config] Current origin:', currentOrigin);
  debug('[Environment Config] Environment variables:', {
    apiUrl: process.env.NEXT_PUBLIC_API_URL,
    clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID,
    docusignEnv: process.env.NEXT_PUBLIC_DOCUSIGN_ENVIRONMENT
  });

  // Base configuration from environment variables
  const config = {
    apiUrl: process.env.NEXT_PUBLIC_API_URL,
    clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID,
    tenantId: process.env.NEXT_PUBLIC_AZURE_TENANT_ID,
    redirectUri: currentOrigin,
    apiScopeId: process.env.NEXT_PUBLIC_API_SCOPE_ID,
    docusignEnvironment: process.env.NEXT_PUBLIC_DOCUSIGN_ENVIRONMENT
  };

  debug('[Environment Config] Final config:', config);
  return config;
}